/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'
import { type Image, ImageSchema } from './image'
import { type VideoAssetFile, VideoAssetFileSchema } from './video'

/* TypeScript */
export type VideoContent = {
  image?: Maybe<Image>
  video?: Maybe<{
    title: string
    description?: Maybe<string>
    file: VideoAssetFile
  }>
  id: string
}

export type VideosBlockApiProps = {
  technicalName?: Maybe<string>
  subtitle?: Maybe<string>
  title?: Maybe<string>
  videos: VideoContent[]
  ctaLink?: Maybe<CTALink>
}

/* Schemas */
export const VideoContentSchema = z.object({
  image: z.nullish(ImageSchema),
  video: z.nullish(
    z.object({
      title: z.string(),
      description: z.nullish(z.string()),
      file: VideoAssetFileSchema,
    }),
  ),
  id: z.string(),
})

export const VideosBlockApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  title: z.nullish(z.string()),
  videos: z.array(VideoContentSchema),
  ctaLink: z.nullish(CTALinkSchema),
})

/* Schemas validation */
type TestVideosBlockProps = ExpectTrue<
  Equal<VideosBlockApiProps, z.infer<typeof VideosBlockApiPropsSchema>>
>
